import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"




const apis = {
    //获取排版列表
    selPer(phone) { //查询期刊
    return request({
      url: "/sys/common_user/selPer",
      method: 'post',
      data: {
        phone:phone
      }
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  scheduling(id) {
    return request({
      url: issueUrl,
      method: 'get',
      data: {
        id:id,
      }
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },






}


export default apis



// WEBPACK FOOTER //
// ./src/core/api/system.serve.js